import React, {useState, useEffect} from 'react'
import NetflixLogo from "../media/NetflixLogo.png"

const Header = () => {
  const [show, handleShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll",()=>{
      if (window.scrollY>100){
          handleShow(true);
      } else handleShow(false);
    });
    return ()=>{
      // window.removeEventlistener("scroll");
      // console.log("removedEventListner")
    };
  }, []);


  return (
    <>
    <div className={`${show? "navbar-show":"navbar-hidden"}`} >
    <img
      className="navbar-logo"
      src={NetflixLogo}
      alt="Netflix Logo"
    />
    </div>
    </>
  )
}

export default Header